import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import sha256 from 'crypto-js/sha256';
import { insertFixedSequences } from "./utils";
export var secureRequestInterceptor = function secureRequestInterceptor(config) {
  var timestamp = new Date().toISOString();
  // Создание хэша из текущего времени
  var timestampHash = sha256(Date.now().toString()).toString();
  // Вставка фиксированных последовательностей в хэш
  var requestId = insertFixedSequences(timestampHash, config === null || config === void 0 ? void 0 : config.secretKeys);

  // Создание подписи запроса на основе URL, requestId и времени
  var requestSign = sha256(config.url + requestId + timestamp).toString();
  return _objectSpread(_objectSpread({}, config), {}, {
    headers: _objectSpread(_objectSpread({}, config.headers), {}, {
      'X-Request-Id': requestId,
      'X-Request-Sign': requestSign,
      'X-Request-Timestamp': timestamp
    })
  });
};
export function softSecureRequestInterceptor(filter) {
  return function (config) {
    return filter(config) ? secureRequestInterceptor(config) : config;
  };
}